import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_theme_instance_ext_RowClass} from '../../../dbschema';

export class ThemeInstanceExtensionContainerModel extends BaseContainerModel{

  bl_cms_theme_instance_ext: bl_cms_theme_instance_ext_RowClass = new bl_cms_theme_instance_ext_RowClass();
}
